module.exports = __webpack_public_path__ + "img/man_juggling.d274aefd.gif";